import React, { useState, useEffect } from "react";
import style from "./ChannelProgress.module.css";
import Button from "../../component/button/Button";

const ChannelProgress = ({ setShowAddChannel }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (progress >= 50) return;

        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 49) {
                    clearInterval(interval);
                }
                return prev + 1;
            });
        }, 100);

        return () => clearInterval(interval);
    }, [progress]);

    const handleClick = () => {
        setShowAddChannel(true);  
    };

    return (
        <div>
            <div className={style.innerText}>
                <div className={style.paraText}>Uploading Channel to Platform</div>
                <div className={style.progressBarContainer}>
                    <div
                        className={style.progressBar}
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                <Button className={style.arrowIcon} onClick={handleClick}>
                    Add Channel
                </Button>
            </div>
        </div>
    );
};

export default ChannelProgress;
